import axiosInstance from "./service-instance";

export default {
    getCaseAgreementData: (caseId, docId, refresh , legality_doc_id) =>{
        let url = legality_doc_id ? "/case/v2/leegality/" : "/legality/v3/legality/";

        return axiosInstance.get(url, {
            params: {
                case_id: caseId,
                document_id: docId,
                refresh: refresh
            }
        })
    }
   ,
    getCreateReferenceData: (caseId) =>
        axiosInstance.get("/case/v2/leegality/references/",{
            params:{
                case_id: caseId,
            }
        }),
    getUserLegalityDropdown: () =>
        axiosInstance.get("/user/list/user-legality/", {
            
        }),
    
    deleteAgreementRequest: (caseId, docId , legality_doc_id, remarks) =>{
        let url = legality_doc_id ? "/case/v2/leegality/" : "/legality/v3/legality/";
        return  axiosInstance.delete(url, {
            params: {
                case_id: caseId,
                document_id: docId,
            },
            data: {
                remarks: remarks,
            }
        })
    },
    manuallySingedRequest: (caseId, docId , legality_doc_id) =>{
        let url = legality_doc_id ? "/case/v2/leegality/marked_manually_signed/" : "/legality/v3/marked_manually_signed/";

        return  axiosInstance.post(url, {
            case_id: caseId,
            document_id: docId
        })
    },
    createReference: (caseId, formFieldsData) => {
        return  axiosInstance.post(`case/${caseId}/legality/create-reference/`, formFieldsData);
    },

    sendEmailDetails: (caseId, docId) =>
        axiosInstance.post("/case/v2/leegality/send_email/", {
            case_id: caseId,
            document_id: docId,
        }),

    triggerAgreement: (payload , hitSignzy) =>{
        let url = hitSignzy ? "/legality/v3/legality/" : "/case/v2/leegality/";
        return  axiosInstance.post(url, payload)
    },
    reinitiateAgreement: (caseId, docId) =>
        axiosInstance.post("/case/v2/leegality/reinitiate_expire_url/", {
            case_id: caseId,
            document_id: docId,
        }),
    changeManualSigned: (case_id, id) =>
        axiosInstance.post("/case/v2/leegality/manual-sign/", {
            case_id,
            id,
        }),
    getEsignAgreementData: (gstin, document_id, refresh, legality_data, mpa_approval_id = undefined)  => {
        let url = ''
        if(legality_data && legality_data.document_id){
            url = `/company/esign_agreement/?gstin=${gstin}&document_id=${document_id}&refresh=${refresh}` 
        }else if(legality_data && !legality_data.document_id){
            url = `/legality/v3/db/create-template/?gstin=${gstin}&document_id=${document_id}&refresh=${refresh}`
        }
        return axiosInstance.get(url , {
            params: {
                "mpa_approval_id" : mpa_approval_id
            }
        });
    },
    
    deleteEsignAgreementData: (company_id, docId , legality_doc_id)  => {
        let url = legality_doc_id ? 'company/esign_agreement/' : `/legality/v3/db/create-template/`
        return axiosInstance.delete(url ,  {
            params: {
                company_id: company_id,
                document_id: docId
            }
        });    
    },
    triggerFinnOneId: (caseId,finnOneId) =>
        axiosInstance.post("/case/idfc_finnone_creation/",{
            finnone_id:finnOneId,
            case_id:caseId,
        }),
    triggerEsign : (payload) => 
        axiosInstance.post("/legality/template/sign/", payload),
           
    triggerDBEsign : (payload) =>
        axiosInstance.post("/legality/v3/db/signzy-esign/", payload),

    previewPdfValidation: (caseId) =>
        axiosInstance.get("/case/v2/leegality/tl_pdf_preview_validation/", {
            params: {
                case_id: caseId,
            }
        }),

    previewPdfAnnotated: (caseId) =>
        axiosInstance.get("/case/v2/leegality/tl_pdf_preview_annotated/", {
            params: {
                case_id: caseId,
            },
            responseType: "blob"
        }),

    getPsKitRetriggerReasons: (caseId) =>
        axiosInstance.get("/case/v2/leegality/retrigger/", {
            params: {
                case_id: caseId,
            }
        }),

    retriggerPsKit: (caseId, reasons) =>
        axiosInstance.post("/case/v2/leegality/retrigger/", {
            case_id: caseId,
            reasons: reasons,
        }),

    savePreviewRemarks: (caseId, remarks) =>
        axiosInstance.post("/case/v2/leegality/tl_pdf_preview_remark/", {
            case_id: caseId,
            remarks: remarks,
        }),

};